import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { createcourse, updatecourse, getcourse, deletecourses } from '../../ReduxToolkit/Slice/Academic/Course';
import JoditEditor from 'jodit-react';
import { ToastContainer, toast } from "react-toastify";
import CommanTable from '../../components/Table/CommanTable';


function Course() {
    const dispatch = useDispatch();
    const closeButtonRef = useRef(null);
    const { status, courses } = useSelector((state) => state.course);
    const [courseName, setcourseName] = useState("");
    const [imageInput, setImageInput] = useState(null);
    const [duration, setDuration] = useState("");
    const [description, setDescription] = useState("");
    const [isDescriptionValid, setIsDescriptionValid] = useState(true);
    // create
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!description) {
            setIsDescriptionValid(false);
            alert("Description is required");
            return;
        }
        try {
            setIsDescriptionValid(true);
            const formData = new FormData();
            formData.append('Image', imageInput === null ? "" : imageInput);
            formData.append('courseName', courseName);
            formData.append('duration', duration);
            formData.append('description', description);
            dispatch(createcourse(formData));
            setImageInput(null);
            setcourseName("");
            setDescription("");
            setDuration("");
            closeButtonRef.current.click();
        } catch (error) {
            toast.error("Something went wrong");
        }
    };

    const handleEdit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('Image', imageInput === null ? "" : imageInput);
        formData.append('courseName', courseName);
        formData.append('duration', duration);
        formData.append('description', description);
        dispatch(updatecourse({ selectedId, formData }));
        // Reset fields after submission
        setImageInput(null);
        setcourseName("");
        setDescription("");
        setDuration("");
    };


    //  get
    useEffect(() => {
        if (status === "idle") {
            dispatch(getcourse())
        }
    }, [dispatch, status]);
    // delete api
    const handleDelete = (courseid) => {
        const Isconfirmed = window.confirm("Are you sure! you want delete this course?")
        if (Isconfirmed) {
            dispatch(deletecourses(courseid))
        };
    }
    // single data fetch
    const [updateButton, setupdateButton] = useState("d-none")
    const [SubmitButton, setSubmitButton] = useState("")
    const [selectedId, setSelectedId] = useState(null);
    const handlid = (id) => {
        const selectecourse = courses.data.find(course => course._id === id);
        setcourseName(selectecourse.courseName);
        setImageInput(selectecourse.Image);
        setDescription(selectecourse.description);
        setDuration(selectecourse.duration);
        // setPrice(selectecourse.price);
        setSelectedId(id);
        if (selectecourse) {
            setupdateButton("")
            setSubmitButton("d-none")
        }
        else { }
    };
    // update
    function formatDate(dateString) {
        const options = { year: "numeric", month: "short", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined, options);
      }
    const columns = [
        { label: "Course Name", accessor: "courseName" },
        { label: "Duration", accessor: "duration" },
        { label: "Description", accessor: "description" },
        { label: "Date", accessor: "createdAt", formatter: formatDate },

        
    ];
    return (
        <>
            <div>
                <ToastContainer />
                <div className='d-flex justify-content-between my-3'>
                    <h3>Course</h3>
                    <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#exampleModal"><i className='bi bi-plus-circle-fill'></i>  Course </button>
                </div>

                <CommanTable
                    columns={columns}
                    data={courses.data || []}
                    status={status}
                    onDelete={handleDelete}
                    onEdit={handlid}
                    databstarget="#exampleModal"
                    model="modal"
                />
            </div>

            {/* Modal  */}
            <div
                className="modal fade"
                id="exampleModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                Upload course
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="mb-3 col-lg-6">
                                        <label htmlFor="courseName" className="form-label">
                                            Course Name
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            className="form-control"
                                            id="courseName"
                                            name="courseName"
                                            value={courseName}
                                            onChange={(e) => setcourseName(e.target.value)}
                                            placeholder="Course Name"
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-6">
                                        {/* Displaying the selected image could require additional handling not shown here */}
                                        <label htmlFor="Image" className="form-label">
                                            Image
                                        </label>
                                        <input
                                            required
                                            type="file"
                                            className="form-control"
                                            id="Image"
                                            // value={Image}
                                            name="Image"
                                            onChange={(e) => setImageInput(e.target.files[0])} // Update to setImageInput
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-6">
                                        <label htmlFor="duration" className="form-label">
                                            Duration
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            className="form-control"
                                            id="duration"
                                            name="duration"
                                            value={duration}
                                            onChange={(e) => setDuration(e.target.value)}
                                            placeholder="Duration"
                                        />
                                    </div>
                                    {/* <div className="mb-3 col-lg-6">
        <label htmlFor="price" className="form-label">
            Price
        </label>
        <input
            type="text"
            required
            className="form-control"
            id="price"
            name="price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="Price"
        />
    </div> */}
                                    <div className="mb-3 col-lg-12">
                                        <label htmlFor="description" className="form-label">
                                            Description
                                        </label>
                                        <JoditEditor
                                            required={true}
                                            value={description}
                                            tabIndex={1}
                                            onBlur={newDescription => setDescription(newDescription)}
                                            onChange={newDescription => { }}

                                        />
                                    </div>
                                    <div className={`modal-footer ${SubmitButton}`}>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-bs-dismiss="modal"
                                            ref={closeButtonRef}
                                        >
                                            Close
                                        </button>

                                        <button type="submit" className={`btn btn-primary`}>
                                            Upload
                                        </button>
                                    </div>
                                </div>

                            </form>
                            <button type="submit" onClick={handleEdit} className={`btn btn-primary ${updateButton}`} data-bs-dismiss="modal"  >
                                Update
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Course;
